import classNames from 'classnames'

import styles from './CoolHeader.module.scss'

type Props = {
  children: string
}

const CoolHeader = ({ children }: Props) => (
  <div className={classNames(styles.container, 'card shadow-sm')}>
    <h3 className='m-2' dangerouslySetInnerHTML={{ __html: children }}></h3>
  </div>
)

export default CoolHeader
